import { Checkbox } from 'primereact/checkbox';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import MenuItemIcon from '../MenuItemIcon';

class InputCheckboxComponent extends Component {
    renderView() {
        const {
            colClass,
            id,
            insideTable,
            label,

            negated,
            objectId,
            showLabel,
            titleElement,
            titleElementClass,
            titleElementShowId,
            value,
            validateViewMode,
            validator,
            validators,
            labelClassName,
            showDescription,
            description,
            descriptionClassName,
            iconName,
            iconSide,
            iconSize,
            iconSvg,
            renderLabel,
        } = this.props;
        return  (
            <div className={insideTable ? '' : titleElement ? titleElementClass : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group checkbox'}>
                        {renderLabel ? (
                            renderLabel()
                        ) : label !== undefined && showLabel && !titleElement ? (
                            <label
                                id={`${id}-label-id`}
                                className={
                                    labelClassName && labelClassName !== ''
                                        ? `${labelClassName} p-checkbox-label p-label`
                                        : 'p-checkbox-label p-label'
                                }
                                htmlFor={id}
                                style={{width: '100%'}}
                            >
                                {iconSide === 'left' && iconName !== undefined ? (
                                    <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                ) : null}
                                {iconSide === 'left' && iconSvg !== undefined ? (
                                    <MenuItemIcon id={iconSvg} alt='' className={`icon-svg ${iconSize} ${iconSide}`} iconSvg={iconSvg} />
                                ) : null}
                                {label}
                                {iconSide === 'right' && iconName !== undefined ? (
                                    <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                ) : null}
                                {iconSide === 'right' && iconSvg !== undefined ? (
                                    <MenuItemIcon id={iconSvg} alt='' className={`icon-svg ${iconSize} ${iconSide}`} iconSvg={iconSvg} />
                                ) : null}
                            </label>
                        ) : null}
                        {description !== undefined && showDescription ? (
                            <div>
                                <label htmlFor={`${id}-input-${description}`} className={descriptionClassName}>
                                    {description}
                                </label>
                            </div>
                        ) : null}
                        <span
                            aria-label={label}
                            aria-labelledby={`${id}-label-id`}
                            className={`p-inputtext-view${titleElement ? ' title-element' : ''}`}
                        >
                            {negated ? (!value ? 'TAK' : 'NIE') : value ? 'TAK' : 'NIE'}
                        </span>
                        {titleElement && titleElementShowId ? <span className='p-inputtext-view'>{` ID: ${objectId}`}</span> : null}
                        {validateViewMode && validator ? validator.message(id, label, negated ? !value : value, validators) : null}
                    </div>
                </div>
            </div>
        );
    }

    renderEdit() {
        return this.renderNew();
    }

    renderNew() {
        const {
            colClass,
            disabled,
            id,
            insideTable,
            label,
            renderRequired,
            labelOnRight,
            labelLeftStyle,
            name,
            negated,
            onAfterStateChange,
            onChange,
            showLabel,
            stateField,
            validator,
            validators,
            value,
            labelClassName,
            showDescription,
            description,
            descriptionClassName,
            transparentBorder,
            renderLink,
            grayBorder,
            iconName,
            iconSide,
            iconSize,
            iconSvg,
            renderLabel,
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return  (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group checkbox'}>
                        {renderLabel ? (
                            renderLabel()
                        ) : label !== undefined && showLabel && !labelOnRight ? (
                            <label
                                id={`${id}-label-id`}
                                className={
                                    labelClassName && labelClassName !== ''
                                        ? `${labelClassName} p-checkbox-label p-label`
                                        : 'p-checkbox-label p-label'
                                }
                                htmlFor={`${id}-input`}
                                style={{width: '100%'}}
                            >
                                {iconSide === 'left' && iconName !== undefined ? (
                                    <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                ) : null}
                                {iconSide === 'left' && iconSvg !== undefined ? (
                                    <MenuItemIcon id={iconSvg} alt='' className={`icon-svg ${iconSize} ${iconSide}`} iconSvg={iconSvg} />
                                ) : null}
                                {label}
                                {iconSide === 'right' && iconName !== undefined ? (
                                    <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                ) : null}
                                {iconSide === 'right' && iconSvg !== undefined ? (
                                    <MenuItemIcon id={iconSvg} alt='' className={`icon-svg ${iconSize} ${iconSide}`} iconSvg={iconSvg} />
                                ) : null}
                            </label>
                        ) : null}
                        <div className='checkbox-wrapper'>
                            <Checkbox
                                aria-label={label}
                                aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                                key={id}
                                id={id}
                                inputId={`${id}-input`}
                                name={name}
                                onChange={(e) => (onChange ? onChange('CHECKBOX', [negated], e, onAfterStateChange, stateField) : null)}
                                checked={negated ? !value : value}
                                disabled={disabled || this.viewLikeDisabledRendering()}
                                required={required}
                            />

                            {label !== undefined && showLabel && labelOnRight ? (
                                <label
                                    htmlFor={`${id}-input`}
                                    className={
                                        labelClassName && labelClassName !== ''
                                            ? `${labelClassName} p-checkbox-label p-label ${
                                                  transparentBorder ? 'transparent-border' : ''
                                              } ${grayBorder ? 'gray-border' : ''}`
                                            : `p-checkbox-label p-label ${transparentBorder ? 'transparent-border' : ''} ${
                                                  grayBorder ? 'gray-border' : ''
                                              }`
                                    }
                                    style={labelLeftStyle}
                                >
                                    {iconSide === 'left' && iconName !== undefined ? (
                                        <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                    ) : null}
                                    {iconSide === 'left' && iconSvg !== undefined ? (
                                        <MenuItemIcon
                                            id={iconSvg}
                                            alt=''
                                            className={`icon-svg ${iconSize} ${iconSide}`}
                                            iconSvg={iconSvg}
                                        />
                                    ) : null}
                                    {renderLink !== undefined ? (
                                        <span>
                                            <a href={renderLink} target='_blank' rel='noopener noreferrer'>
                                                {' '}
                                                {renderRequired === true ? (
                                                    <span>
                                                        {' '}
                                                        {label}
                                                        <span className='text-danger'>*</span>
                                                    </span>
                                                ) : (
                                                    label
                                                )}{' '}
                                            </a>
                                        </span>
                                    ) : (
                                        <span>
                                            {renderRequired === true ? (
                                                <span>
                                                    {' '}
                                                    {label} <span className='text-danger'>*</span>
                                                </span>
                                            ) : (
                                                label
                                            )}
                                        </span>
                                    )}

                                    {iconSide === 'right' && iconName !== undefined ? (
                                        <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                    ) : null}
                                    {iconSide === 'right' && iconSvg !== undefined ? (
                                        <MenuItemIcon
                                            id={iconSvg}
                                            alt=''
                                            className={`icon-svg ${iconSize} ${iconSide}`}
                                            iconSvg={iconSvg}
                                        />
                                    ) : null}
                                </label>
                            ) : null}
                        </div>
                        {description !== undefined && showDescription ? (
                            <div>
                                <label htmlFor={`${id}-input-${description}`} className={descriptionClassName}>
                                    {description}
                                </label>
                            </div>
                        ) : null}
                        <div aria-live='assertive'>
                            {validator ? validator.message(id, label, negated ? !value : value, validators) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    viewLikeDisabledRendering() {
        const {viewLikeDisabled, viewMode} = this.props;
        return viewLikeDisabled && viewMode === 'VIEW';
    }
    render() {
        const {rendered, viewMode, viewLikeDisabled} = this.props;
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                    return !!viewLikeDisabled ? this.renderEdit() : this.renderView();
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputCheckboxComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    insideTable: false,
    labelOnRight: false,
    objectId: '',
    rendered: true,
    showLabel: true,
    stateField: 'element',
    titleElement: false,
    titleElementClass: 'col-md-12',
    titleElementShowId: false,
    validateViewMode: false,
    validators: 'required|boolean',
    viewMode: 'VIEW',
    labelClassName: '',
    showDescription: false,
    renderRequired: false,
    renderLink: undefined,
    descriptionClassName: 'p-checkbox-label',
    transparentBorder: false,
    grayBorder: false,
    iconSide: 'left',
    viewLikeDisabled: false,
    labelLeftStyle: {paddingLeft: '12px'}
};

InputCheckboxComponent.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    label: PropTypes.string,
    labelOnRight: PropTypes.bool,
    labelLeftStyle: PropTypes.object,
    name: PropTypes.string.isRequired,
    negated: PropTypes.bool,
    objectId: PropTypes.string,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    rendered: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    titleElement: PropTypes.bool,
    titleElementClass: PropTypes.string,
    titleElementShowId: PropTypes.bool,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    validators: PropTypes.string,
    value: PropTypes.bool,
    renderRequired: PropTypes.bool,
    viewMode: PropTypes.string,
    labelClassName: PropTypes.string,
    description: PropTypes.string,
    showDescription: PropTypes.bool,
    renderLink: PropTypes.string,
    descriptionClassName: PropTypes.string,
    iconName: PropTypes.string,
    iconSide: PropTypes.string,
    iconSize: PropTypes.string,
    iconSvg: PropTypes.string,
};

export default withTranslation()(InputCheckboxComponent);
